/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../Components/Modal/modal.js';
import {
  ENABLE_DISABLE_SKILL_DIALOG,
  CANCEL_TEXT,
} from '../../Constants/strings.js';
import './enableDisableSkillDialog.scss';
import alertIcon from '../../Assets/images/svg/alert_icon.svg';

const EnableDisableSkillDialog = ({
  handleCloseAction,
  selectedSkill,
  handleEnableDisableAction,
  setIsDialogOpen,
  setRows,
  handleSnackbar,
  setIsEdit,
}) => {
  const content = selectedSkill.isActive
    ? ENABLE_DISABLE_SKILL_DIALOG.DISABLE
    : ENABLE_DISABLE_SKILL_DIALOG.ENABLE;

  return (
    <FormDialog
      open={selectedSkill !== null}
      title={content.TITLE_TEXT}
      PaperProps={{}}
      dialogCss="dialog-message"
      dialogPaperCss="skill-enable-dialog-paper"
      width={360}
      height={205}
      dialogBodycontent={
        <div className="dialog-body-text">
          <div className="dialog-alert-icon">
            <img alt="Alert Icon" className="icon-image" src={alertIcon} />
          </div>
          <div className="dialog-message-text">{content.MESSAGE_TEXT}</div>
        </div>
      }
      button1={CANCEL_TEXT}
      cancelButtonId={'cancel-' + content.BUTTON_ID}
      button2={content.BUTTON_TEXT}
      submitButtonId={content.BUTTON_ID}
      button2Action={() =>
        handleEnableDisableAction(
          selectedSkill,
          setRows,
          setIsDialogOpen,
          handleSnackbar,
          setIsEdit,
        )
      }
      button1Action={() => handleCloseAction(setIsDialogOpen, setIsEdit)}
    />
  );
};

EnableDisableSkillDialog.propTypes = {
  handleCloseAction: PropTypes.func.isRequired,
  handleEnableDisableAction: PropTypes.func.isRequired,
  selectedSkill: PropTypes.object.isRequired,
  setIsDialogOpen: PropTypes.func.isRequired,
  setRows: PropTypes.func.isRequired,
  handleSnackbar: PropTypes.func.isRequired,
  setIsEdit: PropTypes.bool,
};

export default EnableDisableSkillDialog;
